import { createLogic } from 'redux-logic';

import requestErrorHandler from 'lib/requestErrorHandler';

import updateDataHelper from 'utils/updateDataHelper';

import { dataApiRequest, dataApiSuccess } from 'state/data/actions';
import { showNotification } from 'state/notifications/actions';
import { currentUserClinicIdSelector } from 'state/concepts/session/selectors';
import { removeOnboardingVirtualClinicLogoEndpoint } from '../endpoints';
import { REMOVE_ONBOARDING_VIRTUAL_CLINIC_LOGO } from '../types';

const removeOnboardingVirtualClinicLogoOperation = createLogic({
  type: REMOVE_ONBOARDING_VIRTUAL_CLINIC_LOGO,
  latest: true,

  async process({ httpClient, getState }, dispatch, done) {
    const state = getState();
    const clinicId = currentUserClinicIdSelector(state);
    const { url, endpoint } = removeOnboardingVirtualClinicLogoEndpoint(clinicId);

    dispatch(dataApiRequest({ endpoint }));

    try {
      await httpClient.delete(url);

      const response = updateDataHelper(
        state.data, 'clinic', clinicId,
        {
          attributes: {
            logoUrls: null,
          },
        },
      );

      dispatch(showNotification({
        messageObject: { id: 'notifications.clinicLogoRemoved' },
      }));
      dispatch(dataApiSuccess({ response }));
    } catch (error) {
      dispatch(showNotification({
        messageObject: { id: 'notifications.clinicLogoRemovedError' },
        kind: 'error',
      }));
      requestErrorHandler({ error, dispatch, endpoint });
    }

    done();
  },
});

export default removeOnboardingVirtualClinicLogoOperation;
